module.exports = __webpack_public_path__ + "static/img/innuote.7dfecb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/phone/innuote.jpg
// module id = PzZ8
// module chunks = 1